<header class="app-navbar">
  <button type="button" class="navbar-toggle" (click)="sidebarToggle()" aria-label="Toggle navigation">
    <i class="fa fa-bars"></i>
  </button>

  <div class="navbar-title">{{ getTitle() }}</div>

  <div class="navbar-user">
    <span class="navbar-user-text">
      Welcome, <strong>{{ (cache.auth$ | async)?.username }}</strong>
    </span>
    <img class="navbar-user-avatar"
         src="https://hsbooster.eu{{ (cache.auth$ | async)?.picture }}"
         onerror="this.src='/assets/img/1177568.png'" alt="">
  </div>
</header>
